import React from 'react';
import { ArrowRight } from 'lucide-react';
import { SYSTEMS } from '@/components/proepoxy/productData';

const SystemSelection = ({ onSelect }) => {
  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <h1 className="text-2xl md:text-3xl font-bold text-[#27292E] mb-2">
          ProEpoxy Order Builder
        </h1>
        <p className="text-gray-600">What system are you installing?</p>
      </div>

      <div className="space-y-4">
        {SYSTEMS.map(system => (
          <button
            key={system.id}
            onClick={() => { if (system.available) onSelect(system.id); }}
            disabled={!system.available}
            className={`w-full p-6 rounded-2xl text-left transition-all border-2 ${
              system.available
                ? 'bg-white hover:border-[#7A0B7A] hover:shadow-lg cursor-pointer border-gray-200'
                : 'bg-gray-50 border-gray-100 cursor-not-allowed opacity-60'
            }`}
            data-testid={`system-${system.id}`}
          >
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-lg font-bold text-[#27292E]">{system.name}</h3>
                <p className="text-sm text-gray-500">{system.description}</p>
              </div>
              {system.available ? (
                <ArrowRight className="w-5 h-5 text-[#7A0B7A]" />
              ) : (
                <span className="text-xs bg-gray-200 text-gray-500 px-3 py-1 rounded-full">Coming Soon</span>
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SystemSelection;
